import { render, staticRenderFns } from "./SalesCustomers.vue?vue&type=template&id=52f96975&scoped=true"
import script from "./SalesCustomers.vue?vue&type=script&lang=js"
export * from "./SalesCustomers.vue?vue&type=script&lang=js"
import style0 from "./SalesCustomers.vue?vue&type=style&index=0&id=52f96975&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f96975",
  null
  
)

export default component.exports